import { NgModule } from '@angular/core';

import { TranslocoModule } from '@ngneat/transloco';

import { SvcFormCustomFieldComponent } from './svc-form-custom-field.component';
import { LibSharedCommonModule } from '@solvace/common';
import { LibSharedComponentModule } from '@solvace/component';
import { SvcControlsModule } from '@solvace/component/svc-controls';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { SvcUserPickerModule } from '../svc-user-picker';
import { SvcLocationFieldModule } from '../svc-location-field';

@NgModule({
  declarations: [
    SvcFormCustomFieldComponent
  ],
  imports: [
    LibSharedCommonModule,
    LibSharedComponentModule,
    TranslocoModule,
    SvcControlsModule,
    NgxSkeletonLoaderModule,
    SvcUserPickerModule,
    SvcLocationFieldModule,
  ],
  exports: [
    SvcFormCustomFieldComponent
  ],
})
export class SvcFormCustomFieldModule { }
